import styled from "styled-components";

export default function ResultSheetModal({
  isOpen,
  onClose,
  path,
}: {
  isOpen: boolean;
  onClose: () => void;
  path: string;
}) {
  return (
    <ResultSheetModalWrap $isOpen={isOpen} onClick={onClose}>
      <ModalContent>
        <Bg $path={path} />
      </ModalContent>
    </ResultSheetModalWrap>
  );
}

const ResultSheetModalWrap = styled.div<{ $isOpen: boolean }>`
  position: fixed;
  display: ${({ $isOpen }) => ($isOpen ? "flex" : "none")};
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  justify-content: center;
  z-index: 10000;
  background: rgba(0, 0, 0, 0.9);
`;
const ModalContent = styled.div`
  position: relative;
  width: 60%;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const Bg = styled.div<{ $path: string }>`
  width: 100%;
  height: 100%;
  background: url(${({ $path }) => $path});
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
`;
